import { loadModules } from 'esri-loader';
import React from 'react';
import ReactDOM from 'react-dom';
import BSLAPopupItemComponent from '../../helpers/BSLAPopupItemComponent';

const BSLAGypsumStackLayer = async () => {
    type layerModules = [typeof import('esri/layers/FeatureLayer')];

    const [FeatureLayer] = await (loadModules(['esri/layers/FeatureLayer']) as Promise<layerModules>);

    return new FeatureLayer({
        title: 'Gypsum Stacks (FDEP)',
        url: 'https://ca.dep.state.fl.us/arcgis/rest/services/OpenData/GYPSUMSTACKS/MapServer/0',
        visible: false,
        popupTemplate: {
            outFields: ['*'],
            title: 'Gypsum Stacks (FDEP)',
            content: (feature: __esri.Feature) => {
                const atts = feature.graphic.attributes;
                const node = document.createElement('div');

                let facility = atts.FACILITY;

                if (atts.NORTHSOUTH) {
                    facility += ` ${atts.NORTHSOUTH}`;
                }

                const content = (
                    <React.Fragment>
                        <BSLAPopupItemComponent label="Basin" value={atts.BASIN_NAME} />
                        <BSLAPopupItemComponent label="Status" value={atts.STATUS} />
                        <BSLAPopupItemComponent label="Company" value={atts.COMPANY} />
                        <BSLAPopupItemComponent label="Facility" value={facility} />
                        <BSLAPopupItemComponent label="Facility ID" value={atts.FACILITY_ID} />
                        <BSLAPopupItemComponent label="Stack Info" value={atts.STACK_INFO} />
                        <BSLAPopupItemComponent label="Location" value={atts.LOCATION} />
                        <BSLAPopupItemComponent label="Area" value={atts.AREA_ACRES} />
                        <p className="mt-3">
                            Gypsum is formed as a by-product in the production of Fertilizer. It’s stored indefinitely because of it’s weak radioactivity. The long range storage is
                            controversial. There are about 25 of these in Florida with most being located in central Florida.
                        </p>
                    </React.Fragment>
                );

                ReactDOM.render(content, node);

                return node;
            }
        }
    });
};

export default BSLAGypsumStackLayer;
